// AppInitializer.tsx
import { useContext } from 'react'
import { useFetchCategoriesListQuery } from 'entities/Categories/api/supplier/apiCategoriesSlice'
import { SupplierContext } from 'context/SupplierContext'

const customer_id = Number(window.config.CUSTOMER_ID)
const parent_id = Number(window.config.CATEGORY_ID)

const AppInitializer = () => {
  const { is_supplier } = useContext(SupplierContext)

  useFetchCategoriesListQuery({ customer_id, parent_id, is_supplier }, { skip: !is_supplier || !customer_id })

  return null
}

export default AppInitializer
